// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-7ioH","textarea":"styles_textarea__2SifO"};